export default {"src":"/_next/static/media/stox.0d15d207.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};